<template>
  <section class="itinerario-poster" ref="sectionRef">
    <div class="stars-container">
      <div 
        v-for="n in 50" 
        :key="n" 
        class="star" 
        :style="generateStarStyle()"
      ></div>
    </div>

    <h2 class="poster-title">Itinerario</h2>

    <!-- 🔥 TEXTO AGREGAasasasasasasdsadDO -->
    <p class="poster-subtext">
      Agradecemos tu puntualidad.<br>
      ¡No queremos empezar sin ti!<br> Llega a tiempo para compartir cada momento especial.
    </p>

    <div
      v-for="(evento, index) in eventos"
      :key="evento.nombre"
      class="poster-item"
      :ref="el => itemRefs[index] = el"
    >
      <img :src="evento.icono" class="poster-icon" />
      <p class="poster-text">
        <span class="evento-nombre">{{ evento.nombre }}</span>
        <span class="evento-hora">{{ evento.hora }}</span>
        <span v-if="evento.nota" class="evento-nota">{{ evento.nota }}</span>
      </p>
    </div>
  </section>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'ItinerarioPoster',
  setup() {
    const eventos = [
      {
        nombre: 'Coctel de bienvenida',
        hora: '7:00 PM',
        icono: require('@/assets/copa1.png')
      },
      {
        nombre: 'Ceremonia',
        hora: '8:00 PM',
        icono: require('@/assets/valss.png')
      },
      {
        nombre: 'Cena',
        hora: '9:00 PM',
        icono: require('@/assets/cena.png')
      },
      {
        nombre: 'Fiesta',
        hora: '9:30 PM - 1:00 AM',
        icono: require('@/assets/disc.png')
      }
    ]

    const itemRefs = ref([])
    const sectionRef = ref(null)

    const generateStarStyle = () => {
      const top = Math.random() * 100
      const left = Math.random() * 100
      const size = Math.random() * 2 + 1
      const duration = Math.random() * 3 + 2
      const delay = Math.random() * 5
      
      return {
        top: `${top}%`,
        left: `${left}%`,
        width: `${size}px`,
        height: `${size}px`,
        animationDuration: `${duration}s`,
        animationDelay: `${delay}s`
      }
    }

    onMounted(() => {
      itemRefs.value.forEach((el, index) => {
        if (!el) return

        const icon = el.querySelector('.poster-icon')
        const text = el.querySelector('.poster-text')

        gsap.set([icon, text], { opacity: 0 })

        const animations = [
          { y: 40 },
          { x: -40 },
          { scale: 0.85 },
          { x: 40 }
        ]

        const fromVars = animations[index % animations.length]

        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return

            gsap.fromTo(
              icon,
              { ...fromVars, opacity: 0 },
              { opacity: 1, x: 0, y: 0, scale: 1, duration: 1, ease: 'power3.out' }
            )

            gsap.fromTo(
              text,
              { y: 20, opacity: 0 },
              { y: 0, opacity: 1, duration: 1, delay: 0.2, ease: 'power2.out' }
            )

            obs.unobserve(entry.target)
          })
        }, { threshold: 0.3 })

        observer.observe(el)
      })
    })

    return { eventos, itemRefs, sectionRef, generateStarStyle }
  }
}
</script>

<style scoped>
.itinerario-poster {
  position: relative;
  background-image: 
    linear-gradient(to bottom, rgba(0, 0, 0, 0.516) 60%, rgba(26, 29, 81, 0.7) 85%, rgba(31, 33, 61, 0.425) 100%),
    url('@/assets/Diseño sin título (7).jpg');
  background-size: cover;
  background-size: cover;
  background-position: center center; 
  background-repeat: no-repeat;
  padding: 60px 20px 80px;
  text-align: center;
  overflow: hidden; /* Evita que las estrellas se salgan */
}

/* Sistema de estrellas */
.stars-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.star {
  position: absolute;
  background: white;
  border-radius: 50%;
  opacity: 0.4;
  box-shadow: 0 0 6px rgba(255, 255, 255, 0.8);
  animation: twinkle linear infinite;
}

@keyframes twinkle {
  0%, 100% { opacity: 0.3; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.2); }
}

.poster-title {
  position: relative;
  z-index: 1;
  font-family: 'Playfair Display', serif;
  font-size: 44px;
  letter-spacing: 2px;
  color: #ffffff; /* Cambiado a blanco para mejor contraste en fondo oscuro */
  margin-bottom: 50px;
}

.poster-item {
  position: relative;
  z-index: 1;
  margin-bottom: 42px;
}

.poster-icon {
  width: 114px;
  height: auto;
  margin-bottom: 12px;
  filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.2));
}

.poster-text {
  font-family: 'Playfair Display', serif;
  color: #ffffff; /* Cambiado a blanco para visibilidad */
  line-height: 1.4;
}

.evento-nombre {
  display: block;
  font-size: 22px;
  font-weight: bold;
}

.evento-hora {
  display: block;
  font-size: 20px;
  font-style: italic;
  margin-top: 4px;
  opacity: 0.9;
}

.poster-subtext {
  text-align: center;
  font-size: 15px;
  max-width: 320px;
  margin: 10px auto 25px;
  line-height: 1.5;
  font-family: 'Playfair Display', serif;
  color: #ffffff; /* Cambiado a blanco para visibilidad */
  opacity: 0.9;
}
</style>